module.exports = __webpack_public_path__ + "img/closeWind.377f70a5.svg";